import React, { FC } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { PopperMenu } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { useAppContext } from 'Jsx/Catalog/context/AppContext';

import type { OrderByOption } from '../../types';

import type { OrderByProps } from './types';

const OrderByDesktop: FC<OrderByProps> = ({ scrollTop }) => {
  const {
    orderBy: { items, itemSelected },
    orderByActions,
  } = useAppContext();
  const { logEvent } = useAmplitude();
  const { t } = useTranslation();

  const onSelectOrderOption = (option: OrderByOption) => {
    if (scrollTop) scrollTop();
    orderByActions.selectOrderBy(option);

    logEvent({
      event: 'Catalog Sort',
      data: {
        'Sort Type': option.label,
        ...getSourceEventParams(),
      },
    });
  };

  return (
    <PopperMenu
      label={t('CATALOG_ORDER_BY')}
      options={items.map(item => ({
        ...item,
        label: t(item.label, { defaultValue: item.label }),
      }))}
      // @ts-expect-error
      onSelected={onSelectOrderOption}
      selected={{
        ...itemSelected,
        label: t(itemSelected.label, { defaultValue: itemSelected.label }),
      }}
    />
  );
};

export default OrderByDesktop;
